// User identity helpers — shared by backend, backoffice and field-recorder.

export type UserNameLike = {
  first_name?: string | null;
  last_name?: string | null;
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
} | null | undefined;

/**
 * The name to show / to auto-fill (e.g. boormeester). Falls back to email when both
 * name parts are empty. Accepts either snake_case (DB) or camelCase shapes.
 */
export function displayName(u: UserNameLike): string {
  if (!u) return '';
  const fn = (u.first_name ?? u.firstName ?? '').trim();
  const ln = (u.last_name ?? u.lastName ?? '').trim();
  const full = [fn, ln].filter(Boolean).join(' ').trim();
  return full || (u.email ?? '').trim() || '';
}
